<template>
  <header role="banner">
    <div class="float-right">
      <I18n />
    </div>
    <h1 v-html="$t('meta.DIo')"></h1>
    <p
      class="lead text-center"
      v-html="$t((this.$route.path.split('/')[2].replace('ernatives', '') || 'meta') + '.title')"
    ></p>
    <hr
      class="trait"
      role="presentation"
    />
  </header>
</template>

<script>
import I18n from 'vue-fs-commons/app/components/partials/I18n.vue';

export default {
  components: {
    I18n,
  },
};
</script>

